var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Row, Col } from "react-bootstrap";
import { isEmpty } from "lodash";
import React, { PureComponent } from "react";
import authentication from "@irati/auth";
import { Hr } from "@irati/ui/src/Layout";
import Markdown from "@irati/ui/src/Markdown";
import { FormattedMessage } from "@irati/utils/lang";
import PerksGOImportantInfo from "@irati-web/perksgo/src/components/PerksGOImportantInfo";
import RedemptionEventImportantInfo from "@irati-web/perks/src/components/RedemptionEventImportantInfo";
import AppOnlyImportantInfo from "@irati-web/perks/src/components/AppOnlyImportantInfo";
import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import { isUserDOBRequired } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
import tracking from "@irati-tracking/perks/perks";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
import Modal from "@irati/ui/src/Modal";
import ImportantInfoList from "../ImportantInfoList";
import StyledH4 from "./styled/H4";
import Wrapper from "./styled/Wrapper";
import TeCModalHeader from "./TeCModalHeader";
import UnavailableDeal from "./UnavailableDeal";
var InlineImportantInfoBlock = /** @class */ (function (_super) {
    __extends(InlineImportantInfoBlock, _super);
    function InlineImportantInfoBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isModalOpen: false
        };
        _this.isPerksGoDeal = function () {
            return authentication.apps("perks.perksGo") && isPerksGO(_this.props.deal);
        };
        _this.openModal = function (deal) {
            tracking.viewTerms(deal);
            _this.setState({ isModalOpen: true });
        };
        _this.closeModal = function () {
            _this.setState({ isModalOpen: false });
        };
        return _this;
    }
    InlineImportantInfoBlock.prototype.render = function () {
        var _this = this;
        var _a = this.props, importantListData = _a.importantListData, termsAndConditions = _a.termsAndConditions, deal = _a.deal, buttonText = _a.buttonText, buttonDisabled = _a.buttonDisabled, onClick = _a.onClick;
        var isModalOpen = this.state.isModalOpen;
        return (React.createElement(Row, null,
            React.createElement(Hr, { large: true }),
            React.createElement(Wrapper, null,
                React.createElement("section", { className: "importantInfoBlock_header" },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(StyledH4, { marginBottom: 2 },
                                React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.importantText" }),
                                React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.infoText" }))))),
                !isEmpty(importantListData) && (React.createElement("section", null,
                    React.createElement(ImportantInfoList, { data: importantListData }))),
                termsAndConditions && (React.createElement("section", { "data-test": "tandcs" },
                    React.createElement(Hr, null),
                    React.createElement(Flex, { justifyContent: "center" },
                        React.createElement(Button, { cta: true, onClick: function () { return _this.openModal(deal); } },
                            React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.tAndC" }))),
                    React.createElement(Modal, { show: isModalOpen, onHide: this.closeModal, renderHeader: TeCModalHeader },
                        React.createElement(Markdown, { source: termsAndConditions }),
                        React.createElement(Flex, { justifyContent: "flex-end", marginTop: 3 },
                            React.createElement(Button, { primary: true, onClick: this.closeModal },
                                React.createElement(FormattedMessage, { id: "perks.components.simpleModal.close" })))))),
                !isDealUnavailable(deal) && (React.createElement(React.Fragment, null,
                    this.isPerksGoDeal() && React.createElement(PerksGOImportantInfo, { deal: deal }),
                    isUserDOBRequired(deal) && (React.createElement(RedemptionEventImportantInfo, { deal: deal, buttonText: buttonText, buttonDisabled: buttonDisabled, emoji: "\uD83C\uDF82", onClick: onClick })),
                    isAppOnly(deal) && React.createElement(AppOnlyImportantInfo, null))),
                isDealUnavailable(deal) && React.createElement(UnavailableDeal, null))));
    };
    InlineImportantInfoBlock.defaultProps = {
        id: "inlineImportantInfoBlock",
        deal: null,
        termsAndConditions: null,
        children: null,
        buttonDisabled: false
    };
    return InlineImportantInfoBlock;
}(PureComponent));
export default InlineImportantInfoBlock;
